import { fetchDatas } from '../../../services/axiosInstanceService';
import { foldersParser } from '../foldersParser';

/**
 * Fetches folders for a given user and parses the result.
 *
 * @async
 * @function
 * @param {string | null} userIdIri - The IRI of the user. If null, an error is thrown.
 * @param {IIdIri[]} users - The list of users used for parsing folder data.
 * @returns {Promise<Folders>} A promise that resolves to the parsed folder data.
 * @throws {Error} If `userIdIri` or `users` are not provided.
 */
async function fetchFolders(
  userIdIri: string | null,
  users: IIdIri[] | null,
  authUserIdIri: string | null,
) {
  try {
    if (!userIdIri) throw new Error('User idIri not found');
    if (!users) throw new Error('Users  not found');
    if (!authUserIdIri) throw new Error('AuthUser  not found');

    const result = await fetchDatas(`${userIdIri}/folders`);

    const parsed = foldersParser(result['hydra:member'], users, authUserIdIri);

    return parsed;
  } catch (error) {
    return Promise.reject(error);
  }
}

export { fetchFolders };
